import { create } from "zustand";

/** Tooltip flottant global de la page (un seul élément DOM) */
export const useTooltipStore = create((set) => ({
    visible: false,
    text: "",
    x: 0,
    y: 0,
    show: (text, x, y) => set({ visible: true, text, x, y }),
    move: (x, y) => set({ x, y }),
    hide: () => set({ visible: false }),
}));
